import React from 'react';
import PropTypes from 'prop-types';
import {  ROLE_ClientUser, ROLE_LocationUser, ROLE_SuperUser, BASE_URL, EMPTY_GUID, validationCreator, SHORT_DATE_FORMAT, IsCurrentUser, IsInRole, allowUserWithRoles, ROLE_OfficeUser } from "../../constants";
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import {apiPost, apiPut, apiRequest} from "../../utils/request";
import {join} from 'lodash';
import { getActionTypeFromUrl, mustBeArray } from '../../utils/lib';
import { Button, Modal, ModalBody, ModalFooter, Form, FormGroup, Label, Input } from 'reactstrap';
import LinkClientAndLocation from './LinkClientAndLocation';
import { toastr } from 'react-redux-toastr';
import moment from 'moment';
import If from '../Common/If';
import LocationUsage from '../Location/subcomponents/LocationUsage.jsx';

const hasRole = (user, role) => {
  if(!user){
    return false;
  }
  if(user.hasOwnProperty('hasRole')){
    return user.hasRole(role);
  }
  return user.roles.findIndex(x => x.roleName == role) >= 0;
};

const ValidationRules = {
  locationClientId: {
    validator: (val, state) => {
      let exp = /^[c|C|l|L]\d+$/;
      return !exp.test(val) ? validationCreator(false, 'Please enter a valid Client or Location Id') : validationCreator();
    }
  },
};


class UserClientLocationControl extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      locations: [],
      clients: [],
      locationsUsage: [],
      loading: true,
      authorisationRequest: {
        locationClientId: '',
      },
      validationMessages: {},
      isLinkClientLocationModalOpen: false,
      isRevokeModalOpen: false,
      revokeAuthorisationRequest: {},
      clientLocationLinked: false
    };
    this.isValid = this.isValid.bind(this);
  }

  componentDidUpdate(prevProps, prevState){
    if(JSON.stringify(this.props.user) !== JSON.stringify(prevProps.user)){
      this.loadUser();
    }
  } 

  componentDidMount(){
    this.loadUser();
  }

  handleCancelLinkingClientLocation = () => {
    this.setState({ isLinkClientLocationModalOpen: false, validationMessages: {},
          authorisationRequest: {...this.state.authorisationRequest, locationClientId: ""}});
  }

  viewLinkClientLocationModal = () => {
    this.setState({ isLinkClientLocationModalOpen: true});
  }

  isValid = (stateItem) => {
    let item = this.state[stateItem];
    let messages = {};
    let isValid = true;

    for (let propName in ValidationRules) {

      let rule = ValidationRules[propName];
      let val = item[propName];

      let valResult = rule.validator(val, this.state);
      if (!valResult.isValid) {
        messages[propName] = valResult.message;
        isValid = false;
      }
    }
    this.setState({validationMessages: messages});

    return isValid;
  }

  handleFieldChange = (e)=> {
    let authorisationRequest = {...this.state.authorisationRequest};
    authorisationRequest[`${e.target.name}`] = e.target.value;
    this.setState({authorisationRequest}, () => this.isValid('authorisationRequest'));
  }

  handleSubmitAuthorisationRequest = ({id, type}) => { 

    let authRequest = {
      toLocationId: type==="location" ? id : null,
      toClientId: type === "client" ? id : null,
      requestedByUserId: this.props.userId,
      originalRequestInfo: null,
      actionType: 1,
      actionedByUserId: this.props.account && this.props.account.user && this.props.account.user.id
    };

    apiPost('/api/AuthorisationRequests/create', authRequest)
      .then(x => {
        if(x.error){
          x.data.json().then(a => toastr.error(a.message));
        } else {
          toastr.success(`${type === "client" ? "Client" : "Location"} linked.`);
          this.setState({ isLinkClientLocationModalOpen: false});
          if(getActionTypeFromUrl() === "linkClientLocation"){
            this.props.redirectToDefaultRoute(); //without search params to link client location
          }
          this.loadUser();
          this.props.requestsUpdated();
        }
      });
    }

    loadUser() {
      this.setState({ loading:true });
      if(this.props.userId && this.props.userId !== EMPTY_GUID) {
        apiRequest(`/api/users/${this.props.userId}`,'GET')
          .then(x => {
          let clients = _.filter(mustBeArray(x.data && x.data.authorisationRequests), o => o.toClientId);
          let locations = _.filter(mustBeArray(x.data && x.data.authorisationRequests), o => o.toLocationId);
          let q = join(mustBeArray(locations).map(m => m.toLocationId), `&locationIds=`);
            apiRequest(`/api/locations/locationUsage?locationIds=${q}`, 'GET')
              .then(y => this.setState({locationsUsage: y.data})); 
          this.setState({
            user: x.data,
            authorisationRequest: {
              locationClientId: '',
            },
            validationMessages: {},
            isLinkClientLocationModalOpen: getActionTypeFromUrl() === "linkClientLocation",
            isRevokeModalOpen: false,
            locations,
            clients,
            loading: false
          });
        });
      }
    }

    revokeRequest = (ar, reason) => {
      let {id} = ar;
      let revokeAuthorisationRequest = {
        reason: !reason ? '' : reason,
        id: ar.id,
      };
  
      if (!reason) {
        this.setState({isRevokeModalOpen: true, revokeAuthorisationRequest});
      }
      else {
        apiPut(`/api/AuthorisationRequests/${id}/revoke`, revokeAuthorisationRequest)
          .then(x => {
            if (x.data && !x.error) {
              toastr.success(`Authorisation request revoked`);
              this.props.requestsUpdated();
              this.loadUser();
              this.setState({isRevokeModalOpen: false, revokeAuthorisationRequest: {}});
            } else {
              toastr.error(`Failed to action request: ${x.error}`);
            }
          });
      }
    }

    toggleRevokeModal = () => {
      this.setState({isRevokeModalOpen: !this.state.isRevokeModalOpen, revokeAuthorisationRequest: {}});
    }

    getActionedDate = ({c}) => {
      let authorisationRequests = mustBeArray(this.state.user && this.state.user.authorisationRequests);
      return c && c.actionedDate ? moment(c.actionedDate).format(SHORT_DATE_FORMAT) : '';
      
    }

    getActionedBy = ({c}) => {
      let authorisationRequests = mustBeArray(this.state.user && this.state.user.authorisationRequests);
        return c && c.actionedByUserName ? c.actionedByUserName : "";
    }

    getRevoked = ({c}) => {
        if(c && c.revokedByUserId) return <div>{`${moment(c.revokedDate).format(SHORT_DATE_FORMAT)} (${c.revokedReason})`}</div>;
        return !IsCurrentUser(this.props.user, this.state.user) && c && c.isActive && c.actionType === 1 && 
        <div>
          <Button
            color="danger"
            onClick={() => this.revokeRequest(c)}
            style={{marginRight: '5px'}}
          >
            <i className="fa fa-times"/>&nbsp;Revoke
          </Button>
        </div>
    }

  render() {
    let {user } = this.props;
    const ClientCols = () => [
      {
        id: 'toClientName',
        Header: <div style={{display: 'none'}}></div>,
        accessor: c => c.toClientName,
        Cell: row => (<div><a href="#" onClick={(e) => {
          e.preventDefault();
          props.onSelect(`${BASE_URL}/manage/clients/${row.original.toClientId}`);
        }}>{row.value}</a></div>),
      },
      {
        Header: 'Actioned',
        id: 'actionedDate',
        accessor: c => this.getActionedDate({c}),
        maxWidth: 120,
      },
      {
        Header: 'Actioned By',
        id: 'actionedByUserName',
        accessor: c => this.getActionedBy({c}),
        maxWidth: 160,
      },
      {
        id: 'revoke',
        Header: 'Revoked',
        accessor: c => this.getRevoked({c}),
        maxWidth: 220
      }
    ];
    const LocationCols = () => [
      {
        id: 'locationUsage',
        Header: <div style={{display: 'none'}}></div>,
        Cell: row => {
          let l =  this.state.locationsUsage.filter(x => x.id == (row.original.toLocationId));
          if(l.length === 0){
            l = [row.original];
          }
          let authorisationRequest = mustBeArray(this.state.user && this.state.user.authorisationRequests);
          let request = _.find(authorisationRequest, o => o.toLocationId === (l[0] && l[0].id));
          return l.map(x => <LocationUsage
                  location={{...x, ...(request || {})}} 
                  showLink 
                  showAuthorisationDetails={true}
                  account={this.props.user}
                  user={this.state.user}
                  getActionedBy={this.getActionedBy}
                  getRevoked={this.getRevoked}
                  getActionedDate={this.getActionedDate}
                  revokeRequest={this.revokeRequest}
                  onSelect={this.props.onSelect} />) ;
        },
        minWidth: 400
      }
    ];
    const linkTitle = hasRole(user, ROLE_ClientUser) ? "Link Client/Location" : "Link Location";
    return (<If 
      condition={hasRole(user, ROLE_ClientUser) || hasRole(user, ROLE_LocationUser)}
      then={
        <If 
          condition={!user || user.userId === EMPTY_GUID}
          then={<h5>Please save the user to link client/location</h5>}
          else={
            <div className="row">
      <div className="col-6 col-md-12">
        <h5>
          Client and location access
          &nbsp;
          {
             allowUserWithRoles(this.props.account, [ROLE_SuperUser, ROLE_OfficeUser]) &&
            <Button color="success" onClick={this.viewLinkClientLocationModal}>
                {linkTitle}
            </Button>
          }
        </h5> 
        {this.state.loading ?
          <h6>Loading...</h6> :
          <div>
            { hasRole(user, ROLE_ClientUser) && <div>
              <h6>Clients</h6>
              <ReactTable
                sortable={false}
                filterable={false}
                showPagination={false}
                data={this.state.clients}
                columns={ClientCols(this.props, this.state)}
                defaultPageSize={100}
                minRows={2}
                style={{marginBottom: '25px'}}
              />
            </div> }
            <div>
                <h6>Locations</h6>
                <ReactTable
                sortable={false}
                filterable={false}
                showPagination={false}
                data={this.state.locations}
                columns={LocationCols(this.props, this.state)}
                defaultPageSize={100}
                minRows={2}
                style={{marginBottom: '25px'}}
              />
            </div>

          </div> }
          <LinkClientAndLocation
              value={this.state.authorisationRequest.locationClientId}
              handleFieldChange={this.handleFieldChange}
              validationMessages={this.state.validationMessages}
              handleSave={this.handleSubmitAuthorisationRequest}
              handleCancel={this.handleCancelLinkingClientLocation}
              isModalOpen={this.state.isLinkClientLocationModalOpen}
              title={linkTitle}
              hasClientUserRole={hasRole(user, ROLE_ClientUser)}
              selectedClients={mustBeArray(this.state.clients)}
              selectedLocations={mustBeArray(this.state.locations)}
            />
            <Modal isOpen={this.state.isRevokeModalOpen} toggle={this.toggleRevokeModal}>
            <ModalBody>
              <Form>
                <FormGroup>
                  <Label for="authorisationRequestReason">Reason for revocation</Label>
                  {this.state.revokeAuthorisationRequest &&
                  <Input type="textarea"
                         name="authorisationRequestRevokeReason"
                         id="authorisationRequestRevokeReason"
                         value={this.state.revokeAuthorisationRequest.reason}
                         onChange={(e) => this.setState({
                           revokeAuthorisationRequest: {
                             ...this.state.revokeAuthorisationRequest,
                             reason: e.target.value
                           }
                         })}

                  />}
                </FormGroup>

              </Form>
            </ModalBody>
            <ModalFooter>
              <FormGroup>
                {(this.state.revokeAuthorisationRequest &&
                  this.state.revokeAuthorisationRequest.reason !== '') &&
                <Button color="danger"
                        onClick={() => this.revokeRequest(this.state.revokeAuthorisationRequest, this.state.revokeAuthorisationRequest.reason)}>Revoke</Button>}
                &nbsp;
                <Button onClick={this.toggleRevokeModal}>Cancel</Button>
              </FormGroup>
            </ModalFooter>
          </Modal>
      </div>
    </div>
          }
        />
      }
      else={<React.Fragment />}
    />);
  }
}

UserClientLocationControl.propTypes = {
  user: PropTypes.object.isRequired,
  onSelect: PropTypes.func.isRequired,
};

export default UserClientLocationControl;
